<template>
  <div id="app">
    <transition v-if="this.$store.getters.getShowMenu">
      <comp-menu></comp-menu>
    </transition>
    <!-- <transition name="fade" mode="out-in"> -->
      <router-view></router-view>
    <!-- </transition> -->
  </div>
</template>

<script>
import CompMenu from '@/components/CompMenu';

export default {
  name: 'app',
  components: {
    CompMenu,
  },
};
</script>

<style lang="scss" src="./scss/app.scss"></style>



// WEBPACK FOOTER //
// src/App.vue